var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer_container"},[_c('div',{staticClass:"offer_head"},[_c('h4',[_vm._v(_vm._s(_vm.offer.name))])]),_vm._v(" "),_c('div',{staticClass:"offer_body_container"},[_vm._t("default"),_vm._v(" "),_vm._t("order")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000cebea","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/Details/ValidationRequestable/Contract/Offer.vue
// module id = 1697
// module chunks = 0